import {BatteryTestStatusActions, BatteryTestStatusActionTypes} from '../actions/battery-test-status.actions';
import {BatteryTestModel} from '../battery-test.model';

export interface State {
  isLoading: boolean;
  isLoaded: boolean;
  entities: BatteryTestModel;
}

export const initialState: State = {
  isLoading: false,
  isLoaded: false,
  entities: {
    date: null,
    code: 3
  }
};

export function reducer(state = initialState, action: BatteryTestStatusActions): State {
  switch (action.type) {

    case BatteryTestStatusActionTypes.LoadBatteryTestStatuss:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload};
    case BatteryTestStatusActionTypes.GetBatteryTestStatuss:
      return {...state, isLoading: true, isLoaded: false};
    case BatteryTestStatusActionTypes.GetBatteryTestStatussFail:
      return {...state, isLoading: false, isLoaded: true, entities: initialState.entities};
    case BatteryTestStatusActionTypes.StartBatteryTest:
      return {...state, isLoading: true, isLoaded: false};

    default:
      return state;
  }
}
